import { RefObject } from 'react';
import { OnNext } from '../types';
import { Interstitial } from './components/interstitial/interstitial';
import { Question } from './components/question/question';
import { SurveyItemProps } from './types';

interface ExtendedSurveyItemProps extends SurveyItemProps {
  onWhyWeAskExpand?: () => void;
  hideWhyWeAsk?: boolean;
  onNext: OnNext;
  questionTitleRef?: RefObject<HTMLDivElement>;
}

export const SurveyItem = ({ surveyItem, onNext, onWhyWeAskExpand, hideWhyWeAsk, questionTitleRef }: ExtendedSurveyItemProps) => {
  switch (surveyItem.questionnaireItemKind) {
    case 'question':
      return <Question question={surveyItem} onWhyWeAskExpand={onWhyWeAskExpand} hideWhyWeAsk={hideWhyWeAsk} questionTitleRef={questionTitleRef} />;
    case 'interstitial': {
      return <Interstitial interstitial={surveyItem} onNext={onNext} />;
    }
    default:
      return <div>Survey item type not implemented</div>;
  }
};
